/** Set at explicit logout; suppresses the guard's auto-login so the user stays signed out. */
export const EXPLICIT_SIGNOUT_KEY = 'df-explicit-signout';
/** One auto-login attempt per browsing session; a second lands on Tier 1 instead of looping. */
export const AUTO_LOGIN_ATTEMPTED_KEY = 'df-auto-login-attempted';
/** Consumed by auth-init.ts before the router's first navigation. */
export const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';
